module.exports = __webpack_public_path__ + "static/media/gtl-bg-black-blur.e3a00ca3.jpg";